import { UsergroupDeleteOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Empty, List, Modal } from "antd";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./_styles.less";
import * as d3 from "d3";

const DashboardModalTitulo = ({ children, bgColor, config }) => {
  const { t } = useTranslation();
  const textColor = d3.hsl(bgColor).l > 0.5 ? "#000" : "#fff";

  return (
    <div>
      <span
        style={{
          backgroundColor: bgColor,
          color: textColor,
          borderRadius: 6,
          padding: "3px 8px",
          fontWeight: 600,
          fontSize: 12,
          marginRight: 6,
        }}
      >
        {children}
      </span>
      {t(config.tituloModal || "")}
    </div>
  );
};

export default function DashboardModal({ isModalOpen, setModalOpen, modalInfo }) {
  const { t } = useTranslation();
  const { nomeTarefa, tipoDataset, tarefaDetailsByNomeTarefa, colorTipo, chartCfg, valorChart } = modalInfo;
  const handleClose = () => setModalOpen(false);

  const membrosFiltered = useMemo(() => {
    if (!tarefaDetailsByNomeTarefa) return [];
    const list = tarefaDetailsByNomeTarefa.membros.filter((m) => m[tipoDataset] !== 0);
    const itensAtribuidos = list.length && list.reduce((acc, membro) => acc + membro[tipoDataset], 0);

    const naoAtribuidos = valorChart - itensAtribuidos;
    return naoAtribuidos > 0
      ? [
          ...list,
          {
            nome: "Não atribuído",
            [tipoDataset]: naoAtribuidos,
            tarefasTempoMedio: tarefaDetailsByNomeTarefa.tarefasTotal - tarefaDetailsByNomeTarefa.tarefasAbertasTotal,
            naoAtribuido: true,
          },
        ]
      : list;
  }, [tarefaDetailsByNomeTarefa, tipoDataset, valorChart]);

  return (
    <Modal
      title={
        <DashboardModalTitulo bgColor={colorTipo} config={chartCfg}>
          {nomeTarefa}
        </DashboardModalTitulo>
      }
      open={isModalOpen}
      onOk={handleClose}
      onCancel={handleClose}
      bodyStyle={{ padding: "4px 19px" }}
      className={styles["modal-tarefas"]}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
    >
      <List
        className={styles["list-modal-tarefas"]}
        dataSource={membrosFiltered}
        locale={{
          emptyText: <Empty description={t("Nenhum membro associado a este tipo de tarefa")} />,
        }}
        renderItem={(membro) => {
          const rawValue = membro[tipoDataset];
          const value = chartCfg.divisor && !membro.naoAtribuido ? rawValue / (chartCfg.divisor).toFixed(1) : rawValue;
          const unit = tipoDataset === "tempoMedioConclusao" ? (value == 1 ? t("dia") : t("dias")) : rawValue === 1 ? t("item") : t("itens");
          const qtdTarefas = tipoDataset === "tempoMedioConclusao" && t(`[${membro.tarefas ?? membro.tarefasTempoMedio} tarefa${(membro.tarefas ?? membro.tarefasTempoMedio) > 1 ? "s" : ""}]`);

          return (
            <List.Item key={membro.id} style={{ padding: "11px 10px" }}>
              <List.Item.Meta avatar={<Avatar icon={membro.naoAtribuido ? <UsergroupDeleteOutlined /> : <UserOutlined />} />} title={membro.nome} description={membro.email} style={{ alignItems: "center" }} />

              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                <h4 style={{ fontWeight: "bold", marginBottom: 4 }}>{tipoDataset === "tempoMedioConclusao" ? t("Tempo") : t("Total")}</h4>

                <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>
                  {value} {unit} {qtdTarefas}
                </span>
              </div>
            </List.Item>
          );
        }}
      />
    </Modal>
  );
}
